/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-minimize': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M3.75 10.625v1.25h3.494L1.25 17.863l.881.887 5.994-5.994v3.494h1.25v-5.625H3.75zm15-8.488l-.881-.887-5.994 5.994V3.75h-1.25v5.625h5.625v-1.25h-3.494l5.994-5.987z"/>'
  }
})
